import React, { useState } from 'react';
import '@app/Login/login.css';
import PropTypes from 'prop-types';
import toast, {Toaster} from 'react-hot-toast'
import AdVoltBolt from '../../../assets/images/Lightning_Bolt_on_Circle.svg'
import {LoginForm} from "@patternfly/react-core";
import AdVoltLogo from '../../../assets/images/AdVolt-logo-white-500px.png'
import {LoginComponent} from "@app/Login/LoginComponent";

async function loginUser(credentials) {
    return fetch(process.env["API_URL"] + '/auth/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
    })
        .then(data => data.json())
}

export default function Login({ setToken }) {

    return(
        <LoginComponent triggerRefresh={setToken} />
    )
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired
}